import Service from '@ember/service';

export default Service.extend({
  canGoBack() {
    return window.history && window.history.length > 1;
  },

  back() {
    return window.history.back();
  },
});
